import { UsersList } from "../../../../Users"

export default function OrganizationUsersPage() {
	return <UsersList />
}
